import React from 'react';
import { useIntl } from 'react-intl';
import ViewTableInformation from '../../../Common/TableRecords/ViewTableInformation';
import ViewTableBodyInformation from '../../../Common/TableRecords/ViewTableBodyInformation';
import { AdminEarningsIcon } from '../../..//Common/Assets/SvgComponent/SiteAdminSvgIcon';
import messages from '../../../../locale/messages';

const AdminEarning = ({ data }) => {
    const { formatMessage } = useIntl();
    let guestFee = 0, hostFee = 0, convertCurrency, earnings = 0;

    if (data?.cancellationDetails) {
        guestFee = data?.cancellationDetails?.guestServiceFee;
        hostFee = data?.cancellationDetails?.hostServiceFee;
        convertCurrency = data?.cancellationDetails?.currency;
    } else if (data) {
        guestFee = data?.guestServiceFee;
        hostFee = data?.hostServiceFee;
        convertCurrency = data?.currency;
    }
    if (data && (data?.reservationState == 'expired' || data?.reservationState == 'declined')) {
        guestFee = 0;
        hostFee = 0;
    }

    earnings = guestFee + hostFee;
    return (
        <div>
            <ViewTableInformation title={formatMessage(messages.adminEarnings)} icon={<AdminEarningsIcon />}>
                <ViewTableBodyInformation
                    title={formatMessage(messages.guestServiceFee)}
                    currencyData
                    amount={guestFee}
                    convertCurrency={convertCurrency}
                />
                <ViewTableBodyInformation
                    title={formatMessage(messages.hostServiceFeeType)}
                    currencyData
                    amount={hostFee}
                    convertCurrency={convertCurrency}
                />
                <ViewTableBodyInformation
                    title={formatMessage(messages.yourEarnings)}
                    currencyData
                    amount={earnings}
                    convertCurrency={convertCurrency}
                    isBold
                />
            </ViewTableInformation>
        </div>
    )
}

export default AdminEarning;

